import React from "react";
import PropTypes from "prop-types";

function Switch(props) {
    const { checked, onChange, label, id, className } = props;
    return (
        <div className={`trpr__switch ${className}`}>
            <input
                id={id}
                type="checkbox"
                checked={checked}
                className="switch is-rounded is-outlined"
                onChange={onChange}
            />
            <label htmlFor={id}>
                <span>{label}</span>
            </label>
        </div>
    );
}

Switch.propTypes = {
    id: PropTypes.string.isRequired,
};

Switch.defaultProps = {
    label: "label",
    checked: true,
    onChange: () => {},
};

export default Switch;
